import { render, staticRenderFns } from "./EditInvoiceClient.vue?vue&type=template&id=4b899218"
import script from "./EditInvoiceClient.vue?vue&type=script&lang=js"
export * from "./EditInvoiceClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports